import Address from 'components/AddressPicker/Address/Address';

export default Address;
